import React from "react";
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  dark?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  dark = false
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-35" data-mp="3f2n9g4plp4u6">
      {eyebrow && <p className={`text-xs font-bold uppercase tracking-[0.14em] ${dark ? "text-gold" : "text-brand-600"}`} data-id="element-36" data-mp="3k1865u5n96dv">
          {eyebrow}
        </p>}
      <h2 className={`mt-3 text-balance font-serif text-[1.9rem] font-black leading-[1.12] sm:text-4xl md:text-5xl ${dark ? "text-white" : "text-ink"}`} data-id="element-37" data-mp="bmpw5mw57grm">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-pretty text-base leading-relaxed md:text-lg ${dark ? "text-brand-100" : "text-muted"}`} data-id="element-38" data-mp="6svd8lod35tl">
          {subtitle}
        </p>}
    </div>;
}